import { styled } from "@mui/material/styles";

// Components
import { Typography } from "@mui/material";

const styledName = "WalletChooseType";

export const StyledLabel = styled(Typography, { name: styledName })({
  "&": {
    textAlign: "center",
    fontSize: "1.6rem",
  },
});

export const StyledAction = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    marginTop: "50px",
    width: "100%",
  },
});

export const StyledButton = styled("div", { name: styledName })({
  "&": {
    cursor: "pointer",
    ":active": {
      transform: `scale(0.98)`,
    },
    transition: `transform 0.1s ease-out`,
  },
});
